import { css, Stack, styled } from '@mui/material';

export const FormationContainer = styled(Stack)(
  ({ theme }) => css`
    position: absolute;
    bottom: ${theme.spacing(2)};
    right: ${theme.spacing(2)};
  `,
);
